// extracted by mini-css-extract-plugin
export var bullet = "_nf-q";
export var bulletText = "_nf-p";
export var bullets = "_nf-k";
export var callout = "_nf-g";
export var calloutBody = "_nf-i";
export var calloutLabel = "_nf-h";
export var checkIcon = "_nf-m";
export var checkList = "_nf-j";
export var checkSvg = "_nf-n";
export var checkText = "_nf-o";
export var fieldCard = "_nf-1";
export var fieldDescription = "_nf-5";
export var fieldHeader = "_nf-3";
export var fieldTitle = "_nf-4";
export var finalNote = "_nf-s";
export var flow = "_nf-x";
export var flowArrow = "_nf-v";
export var flowStep = "_nf-u";
export var helperText = "_nf-r";
export var inlineTitle = "_nf-t";
export var listItem = "_nf-l";
export var noteBody = "_nf-8";
export var noteBodyText = "_nf-9";
export var noteCard = "_nf-2";
export var noteIcon = "_nf-6";
export var noteTitle = "_nf-7";
export var productChoices = "_nf-w";
export var radioDot = "_nf-d";
export var radioDotSelected = "_nf-e";
export var radioDotSvg = "_nf-f";
export var selectableCard = "_nf-b";
export var selectableCardSelected = "_nf-c";
export var strongText = "_nf-a";
export var subHeading = "_nf-0";